module.exports = __webpack_public_path__ + "media/images/flags/gf-6afd8f4016969204c231f5f7df1e2ce6.svg";